import { render } from "./ClientsListModal.vue?vue&type=template&id=10555ebe"
import script from "./ClientsListModal.vue?vue&type=script&lang=js"
export * from "./ClientsListModal.vue?vue&type=script&lang=js"

import "./ClientsListModal.vue?vue&type=style&index=0&id=10555ebe&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__